import React from 'react'

function Services() {
    return (
        <section id="services" className="services">
            <div className="container">

                <div className="section-title">
                    <h2>Services</h2>
                    <p>My Services</p>
                </div>

                <div className="row">
                    <div className="col-lg-4 col-md-6 d-flex align-items-stretch">
                        <div className="icon-box">
                            <div className="icon "><i className="ri-layout-6-line"></i></div>
                            <h4><a href="javascript:void(0)">Web design and development</a></h4>
                            <p>Websites are key revenue generation medium. Here, you can get with advanced responsive and animated websites for your company with advanced SEO.</p>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-md-0">
                        <div className="icon-box">
                            <div className="icon"><i class="ri-dashboard-line"></i></div>
                            <h4><a href="javascript:void(0)">Content Management systems</a></h4>
                            <p>A Content Management System (CMS) makes your website’s content easier to manage. Here you can get your own systems.</p>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-lg-0">
                        <div className="icon-box">
                            <div className="icon"><i class="ri-shopping-cart-line"></i></div>
                            <h4><a href="javascript:void(0)">E-Commerce systems</a></h4>
                            <p>The Consumers transfer their shopping habits to the digital companies. Here attractive and engaging ecommerce sites can be bulit for your company.</p>
                        </div>
                    </div>

                </div>

            </div>
        </section>
    )
}

export default Services
